export default __webpack_public_path__ + "static/media/mama.20575d82.png";